import { render } from "./teammembers.vue?vue&type=template&id=d954ff3e&scoped=true"
import script from "./teammembers.vue?vue&type=script&lang=js"
export * from "./teammembers.vue?vue&type=script&lang=js"

import "./teammembers.vue?vue&type=style&index=0&id=d954ff3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d954ff3e"]])

export default __exports__